// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"Image_outerContainer__3h8rU","innerContainer":"Image_innerContainer__qe586"};